import {
  RolePermissions,
  canRead,
  AccessType,
  canCreate,
  canDelete,
  canUpdate,
  PermissionContext,
  useProfile,
} from 'zens-store'

export const usePermissions = (companyId: number) => {
  const profile = useProfile()

  const role = profile.data?.roleForCompany(companyId)

  const hasPermission = (access: AccessType = AccessType.Read, context?: PermissionContext) => {
    if (!context) return false
    const rolePermission = RolePermissions[context]
    if (!rolePermission) return true // this context has no permission rules set
    if (!profile.data) return false // no permission when not logged in
    if (access === AccessType.Create && context === 'company') {
      return profile.data?.isSystemAdministrator // company creation is allowed only for system administrators
    }

    return access === AccessType.Read
      ? canRead(rolePermission(role)) // permission allowed for read
      : access === AccessType.Update
        ? canUpdate(rolePermission(role)) // permission allowed for update
        : access === AccessType.Create
          ? canCreate(rolePermission(role)) // permission allowed for create
          : access === AccessType.Delete
            ? canDelete(rolePermission(role)) // permission allowed for delete
            : false
  }

  return { hasPermission, role, isSysAdmin: profile.data?.isSystemAdministrator ?? false }
}
